<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <!-- <span class="loading-request" v-show="loading"></span> -->
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Validação de faturas</h1>
              </div>
              <div
                id="alert"
                class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
                ><br />
                {{ alert.reason }}
              </div>
              <div>
                <div class="page-amounts">
                  <nav aria-label="...">
                    <ul class="pagination pagination-md">
                      <li class="page-item" :class="{ selected: amount == 3 }">
                        <a @click.prevent.stop="setAmountPerPage(3)" class="page-link paginate"
                          >3</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 10 }">
                        <a @click.prevent.stop="setAmountPerPage(10)" class="page-link paginate"
                          >10</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 50 }">
                        <a @click.prevent.stop="setAmountPerPage(50)" class="page-link paginate"
                          >50</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 100 }">
                        <a @click.prevent.stop="setAmountPerPage(100)" class="page-link paginate"
                          >100</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 150 }">
                        <a @click.prevent.stop="setAmountPerPage(150)" class="page-link paginate"
                          >150</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="70"
                        :class="{ 'table-sorted': sortType == 'contract_id' }"
                        @click="sortCall('contract_id')"
                      >
                        ID Contrato
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'contract_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'contract_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'contract_id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle pointer" width="100">ID Fatura</td>
                      <td nowrap class="text-center align-middle pointer" width="100">Cliente</td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'billing_month' }"
                        @click="sortCall('billing_month')"
                      >
                        Mês
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'billing_month' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'billing_month' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'billing_month'"></span>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="100"
                        :class="{ 'table-sorted': sortType == 'price_total' }"
                        @click="sortCall('price_total')"
                      >
                        Status
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'price_total' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'price_total' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'price_total'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="20">Motivo</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.contract_id"
                          v-b-tooltip.hover
                          title="Filtrar por ID do Contrato"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.invoice_id"
                          v-b-tooltip.hover
                          title="Filtrar por ID da Fatura"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.customer_name"
                          v-b-tooltip.hover
                          title="Filtrar por Nome do Cliente "
                        />
                      </td>
                      <td>
                        <SelectInvoiceBillingMonth
                          :selected="filters.month"
                          @change="setFilter('month', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por mês de cobrança"
                        />
                      </td>
                      <td>
                        <SelectInvoiceValidationStatuses
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por Status"
                        />
                      </td>
                      <td></td>
                    </tr>
                    <tr v-for="(validation, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ validation.contract_id }}
                      </td>
                      <td class="text-center align-middle">
                        {{ validation.invoice_id }}
                      </td>
                      <td class="text-left align-middle">
                        {{ validation.customer.customerable.name }}
                      </td>
                      <td class="text-left align-middle">
                        {{ validation.billing_month | month }}
                      </td>
                      <td
                        class="text-center align-middle font-weight-bold"
                        :class="'status-' + validation.status_id"
                      >
                        {{ validation.status.status }}
                      </td>
                      <td class="text-right align-middle">
                        {{ validation.reason }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click.prevent.stop="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 2"
                      >
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                      >
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                      >
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 2"
                      >
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click.prevent.stop="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';
import SelectInvoiceValidationStatuses from '@/components/forms/SelectInvoiceValidationStatuses';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin';
import { baseApiUrl } from '@/global';

import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'InvoicesValidations',
  components: {
    SelectInvoiceBillingMonth,
    SelectInvoiceValidationStatuses,
  },
  data() {
    return {
      sortType: localStorage.invoicesValidationSortType
        ? localStorage.invoicesValidationSortType
        : 'billing_month',
      sortReverse: localStorage.invoicesValidationSortReverse
        ? localStorage.invoicesValidationSortReverse
        : false,
      amount: localStorage.invoicesValidationDataAmount
        ? localStorage.invoicesValidationDataAmount
        : 50,
      page: localStorage.invoicesValidationDataPage ? localStorage.invoicesValidationDataPage : 1,
      filters: {
        contract_id: localStorage.invoicesValidationContractID
          ? localStorage.invoicesValidationContractID
          : '',
        invoice_id: localStorage.invoicesValidationInvoiceID
          ? localStorage.invoicesValidationInvoiceID
          : '',
        customer_name: localStorage.invoicesValidationCustomerName
          ? localStorage.invoicesValidationCustomerName
          : '',
        month: localStorage.invoicesValidationFilterMonth
          ? localStorage.invoicesValidationFilterMonth
          : '',
        status: localStorage.invoicesValidationFilterStatus
          ? localStorage.invoicesValidationFilterStatus
          : -1,
      },
      data: [],
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      selected: [],
      allSelected: false,
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.contract_id = '';
      this.filters.invoice_id = '';
      this.filters.customer_name = '';
      this.filters.month = '';
      this.filters.status = -1;
      this.filters.sortType = 'billing_month';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('invoicesValidationContractID', this.filters.contract_id);
      localStorage.setItem('invoicesValidationInvoiceID', this.filters.invoice_id);
      localStorage.setItem('invoicesValidationCustomerName', this.filters.customer_name);
      localStorage.setItem('invoicesValidationFilterMonth', this.filters.month);
      localStorage.setItem('invoicesValidationFilterStatus', this.filters.status);
      localStorage.setItem('invoicesValidationSortType', this.sortType);
      localStorage.setItem('invoicesValidationSortReverse', this.sortReverse);
      localStorage.setItem('invoicesValidationDataAmount', this.amount);
      localStorage.setItem('invoicesValidationDataPage', this.page);
    },
    convertFilters() {
      return `?page=${this.page ? this.page : 1}&contract_id=${
        this.filters.contract_id ? this.filters.contract_id : ''
      }&invoice_id=${this.filters.invoice_id ? this.filters.invoice_id : ''}&customer_name=${
        this.filters.customer_name ? this.filters.customer_name : ''
      }&month=${this.filters.month ? this.filters.month : ''}&status=${
        this.filters.status ? this.filters.status : -1
      }&type=${this.filters.type ? this.filters.type : -1}&amount=${this.amount}&sortType=${
        this.sortType
      }&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}`;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/invoice/validation/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    setAmountPerPage(amount) {
      this.amount = amount;
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
<style>
.status-1 {
  color: #00d86b;
}
.status-2 {
  color: #ffc94f;
}
.status-3 {
  color: #ff7575;
}
</style>
